import styled from 'react-emotion';
import { themeGet } from 'styled-system';

// @width
// @flex
// @margin
export const Wrapper = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media screen and (min-width: 76em) {
    &::after {
      content: " ";
      flex: auto;
      min-width: 320px;
      max-width: 350px;
    }
  }
`;

// @width
// @padding
export const Column = styled('div')`
  width: 100%;
  padding: ${themeGet('space.3')}px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 320px;

  @media screen and (min-width: 40em) {
    width: 50%;
    max-width: 350px;
  }

  @media screen and (min-width: 52em) {
    width: 50%;
  }

  @media screen and (min-width: 76em) {
    width: 33.33333333333333333%;
  }
`;



// WEBPACK FOOTER //
// ../shop_main/components/grid/style.js